import React, { useState, useEffect } from 'react';
//import left_img from '../images/left_side_caladine.png';
//import right_img from '../images/right_side_caladine.png';
import { Link } from 'react-router-dom';
import axios from 'axios';
import GrafikData from './GrafikData';

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

let loadPage = true;

export const options = {
    responsive: true,
    plugins: {
        legend: {
            position: 'top',
        },
        title: {
            display: true,
            //text: 'Chart.js Bar Chart',
        },
    },
};

const labels = ['2025','2024', '2023', '2022', '2021', '2020', '2019'];

export const data = {
    labels,
    datasets: [
        {
            label: 'Tidak Berlaku',
            data: [0,1,0,0,1,0],
            backgroundColor: 'rgba(255, 99, 132, 0.5)',
        },
        {
            label: 'Berlaku',
            data: [68,100,84,108,106,43,91],
            backgroundColor: 'rgba(53, 162, 235, 0.5)',
        },
    ],
};


function Grafik() {
    const urlImg = `${process.env.REACT_APP_BASEURL}/images/news/`;

    const [chartData, setChartData] = useState({});
    const [employeeSalary, setEmployeeSalary] = useState([]);
    const [employeeAge, setEmployeeAge] = useState([]);


   
    useEffect(() => {
        if (loadPage) {
            //Chart();
        }
        return () => {
            loadPage = false
        };
    }, []);

    return (
        <div class="max-w-full mx-auto bg-white"><br /><br /><br /><br /><br />
            <div class="max-w-screen-xl mx-auto">
                <div class="grid grid-cols-2 gap-8">
                    <div>
                        <span class="bg-red-600 text-white px-4 py-1 text-sm font-bold rounded-lg">Infografis Produk Hukum</span>
                        <h1 class="text-3xl font-bold mt-4">Grafik JDIH Kota Magelang</h1>
                        <p class="text-gray-600 mt-2">Grafik Status Produk Hukum.</p>
                        {/*<Bar
                            data={chartData}
                            options={{
                                responsive: true,
                                title: { text: "THICCNESS SCALE", display: true },
                                scales: {
                                    yAxes: {
                                        ticks: {
                                            beginAtZero: true
                                        }
                                    }
                                }
                            }}
                        />*/}
                        <Bar options={options} data={data} />
                    </div>

                    <div>
                        <span class="bg-red-600 text-white px-4 py-1 text-sm font-bold rounded-lg">Grafik Kategori Produk Hukum</span>
                        <h2 class="text-3xl font-bold mt-4">&nbsp;</h2>
                        <GrafikData />
                    </div>
                </div>
            </div><br />
        </div>
    );
}

export default Grafik;
